import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import bg from "./bg/signin.svg";
import bgimg from "./bg/backimg.jpg";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useAppStore } from "./appStore";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
  },
});

const boxstyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "75%",
  height: "70%",
  bgcolor: "background.paper",
  boxShadow: 24,
};

const center = {
  position: "relative",
  top: "50%",
  left: "37%",
};

export default function Login() {
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const updateUsername = useAppStore((state) => state.updateUsername);
  const updatePassword = useAppStore((state) => state.updatePassword);

  useEffect(() => {
    updateUsername('');
    updatePassword('');
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    
    // Demo credentials for testing
    const demoCredentials = [
      { username: "admin@demo.com", password: "admin123" },
      { username: "user@demo.com", password: "user123" },
      { username: "test@demo.com", password: "test123" }
    ];
    
    const isValidCredential = demoCredentials.some(
      cred => cred.username === name && cred.password === password
    );
    
    if (isValidCredential) {
      updateUsername(name);
      updatePassword(password);
      Swal.fire({
        icon: 'success',
        title: 'Login Successful!',
        text: 'Welcome to the Dashboard',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        navigate("/products");
      });
    } else {
      Swal.fire(
        "Login Failed!",
        "Please use the demo credentials provided below or enter valid username and password.",
        "error"
      );
    }
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const fillDemoCredentials = (username, password) => {
    setName(username);
    setPassword(password);
  };

  return (
    <>
      <div
        style={{
          backgroundImage: `url(${bgimg})`,
          backgroundSize: "cover",
          height: "100vh",
          color: "#f5f5f5",
        }}
      >
        <Box sx={boxstyle}>
          <Grid container>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundSize: "cover",
                  marginTop: "40px",
                  marginLeft: "15px",
                  marginRight: "15px",
                  height: "63vh",
                  color: "#f5f5f5",
                }}
              ></Box>
            </Grid>
            <Grid item xs={12} sm={12} lg={6}>
              <Box
                style={{
                  backgroundSize: "cover",
                  height: "70vh",
                  backgroundColor: "#3b33d5",
                }}
              >
                <ThemeProvider theme={darkTheme}>
                  <Container>
                    <Box height={35} />
                    <Box sx={center}>
                      <Avatar
                        sx={{ ml: "35px", mb: "4px", bgcolor: "#ffffff" }}
                      >
                        <LockOutlinedIcon />
                      </Avatar>
                      <Typography component="h1" variant="h4">
                        Sign In
                      </Typography>
                    </Box>
                    <Box
                      component="form"
                      noValidate
                      onSubmit={handleSubmit}
                      sx={{ mt: 2 }}
                    >
                      <Grid container spacing={1}>
                        <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }}>
                          <TextField
                            required
                            fullWidth
                            id="email"
                            label="Username"
                            value={name}
                            onChange={handleNameChange}
                            name="email"
                            autoComplete="email"
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ ml: "3em", mr: "3em" }}>
                          <TextField
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            value={password}
                            onChange={handlePasswordChange}
                            type="password"
                            id="password"
                            autoComplete="new-password"
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ ml: "5em", mr: "5em" }}>
                          <Button
                            type="submit"
                            variant="contained"
                            size="large"
                            fullWidth="true"
                            sx={{
                              mt: "10px",
                              mr: "20px",
                              borderRadius: 28,
                              color: "#ffffff",
                              minWidth: "170px",
                              backgroundColor: "#FF9A01",
                            }}
                          >
                            Sign in
                          </Button>
                          {/* <Button
                            type="submit"
                            variant="outlined"
                            size="large"
                            sx={{
                              mt: "10px",
                              borderRadius: 28,
                              minWidth: "170px",
                            }}
                          >
                            Create Account
                          </Button> */}
                        </Grid>
                        <Grid item xs={12} sx={{ ml: "3em", mr: "3em", mt: 2 }}>
                          <Card sx={{ bgcolor: "rgba(255,255,255,0.1)", backdropFilter: "blur(10px)" }}>
                            <CardContent>
                              <Typography variant="h6" sx={{ color: "#ffffff", mb: 1, textAlign: "center" }}>
                                Demo Credentials
                              </Typography>
                              <Divider sx={{ bgcolor: "rgba(255,255,255,0.3)", mb: 2 }} />
                              <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    color: "#ffffff", 
                                    cursor: "pointer", 
                                    "&:hover": { color: "#FF9A01" },
                                    transition: "color 0.2s"
                                  }}
                                  onClick={() => fillDemoCredentials("admin@demo.com", "admin123")}
                                >
                                  <strong>Admin:</strong> admin@demo.com / admin123
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    color: "#ffffff", 
                                    cursor: "pointer", 
                                    "&:hover": { color: "#FF9A01" },
                                    transition: "color 0.2s"
                                  }}
                                  onClick={() => fillDemoCredentials("user@demo.com", "user123")}
                                >
                                  <strong>User:</strong> user@demo.com / user123
                                </Typography>
                                <Typography 
                                  variant="body2" 
                                  sx={{ 
                                    color: "#ffffff", 
                                    cursor: "pointer", 
                                    "&:hover": { color: "#FF9A01" },
                                    transition: "color 0.2s"
                                  }}
                                  onClick={() => fillDemoCredentials("test@demo.com", "test123")}
                                >
                                  <strong>Test:</strong> test@demo.com / test123
                                </Typography>
                              </Box>
                              <Typography variant="caption" sx={{ color: "#cccccc", mt: 2, display: "block", textAlign: "center" }}>
                                Click on any credential to auto-fill the form
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </Box>
                  </Container>
                </ThemeProvider>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
}
